<div id="ht">
    <div id="main-cnt">
        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
                        <span class="breadcrumb">UTENTI</span>
                    </div>
                </ion-buttons>
                <div slot="end" class="notification-div">
                    <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
                        <img [src]="sessionService?.user?.profileImg|s3Link"/>


                    </ion-avatar>
                </div>
                <app-add-bookmark slot="end" pageTitle="Utenti" url="/users"></app-add-bookmark>

            </ion-toolbar>
            <br/>

            <!-- edit da qui... -->

            <div class="flex-collapsible">
                <div class="flex-row header" (click)="showFilters = !showFilters">
                    <div class="flex-1 text-center">
                        <img
                                class="svg-white vertical-middle xsmall"
                                src="./assets/imgs/search.svg"
                        />
                        Ricerca
                        <img
                                class="svg-white vertical-middle xsmall"
                                src="./assets/imgs/filter.svg"
                        />
                    </div>
                </div>

                <div class="panel" *ngIf="showFilters">
                    <div style="text-align: center; padding: 1rem">
                        <input
                                [(ngModel)]="filters.name"
                                name="name"
                                class="text-input full-width block"
                                placeholder="Ricerca per nome"
                                type="search"
                                (keyup)="filterUsers()"
                        />

                        <div class="flex-row">
                            <div class="flex-1 text-left">Ruolo</div>
                            <div class="flex-1 text-right">
                                <ion-select
                                        class="text-input"
                                        [(ngModel)]="filters.role"
                                        name="role"
                                        (ionChange)="filterUsers()"
                                        [value]="filters.role"
                                >
                                    <ion-select-option>Tutti</ion-select-option>

                                    <ion-select-option
                                            *ngFor="let role of roleNames"
                                            [value]="role"
                                    >{{ role }}</ion-select-option
                                    >
                                </ion-select>
                            </div>
                        </div>

                        <div class="flex-row">
                            <div class="flex-1 text-left">Data iscrizione</div>
                            <div class="flex-1 text-right">
                                <input
                                        class="text-input"
                                        type="date"
                                        style="margin-left: 1rem"
                                />
                            </div>
                        </div>

                        <div class="flex-row">
                            <div class="flex-1 text-left">Escludi inattivi</div>
                            <div class="flex-1 text-right">
                                <input type="checkbox"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <h3 class="panel-title">Users</h3>
            <!-- ...a qui -->
        </ion-header>

        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content">
                        <!-- edit da qui... -->

                        <app-list-users #usersList></app-list-users>

                        <!-- ...a qui -->
                    </div>
                </div>
            </div>
        </ion-content>
    </div>
</div>
